const MESSAGE_SELECT_PROJECT = "Wybierz projekt";
const MESSAGE_CONSENT_REQUIRED = "Żeby zagłosować, należy zaznaczyć zgody";
const MESSAGE_VERIFICATION_REQUIRED = "Wybierz sposób potwierdzenia tożsamości";
const MESSAGE_OPTIONAL_LOCAL =
  "Opcjonalnie możesz wybrać jeszcze projekt osiedlowy";
const MESSAGE_OPTIONAL_CITY =
  "Opcjonalnie możesz wybrać jeszcze projekt ponadosiedlowy";

const LOCAL_PROJECT_SELECT = "#project1";
const CITY_PROJECT_SELECT = "#project2";
const CONSENT_CHECKBOX = "#residentConsent";
const SUBMIT_BUTTON = "#voteSubmit";
const VERIFICATION_INPUT = ".verificationTile__input";
const VERIFICATION_GROUP = ".verificationMethod";

const HEADER_OFFSET = 90;

$(document).ready(() => {
  updateFormLock();

  $(SUBMIT_BUTTON).on("click", (event) => {
    if (!isFormValid()) {
      event.preventDefault();
      scrollToFirstError();
    }
  });

  $(LOCAL_PROJECT_SELECT + ", " + CITY_PROJECT_SELECT).on("change", () => {
    validateProjects();
    updateFormLock();
  });

  $(CONSENT_CHECKBOX).on("change", () => {
    validateConsent();
    updateFormLock();
  });

  $(VERIFICATION_INPUT).on("change", () => {
    validateVerification();
    updateFormLock();
  });

  $(".form-group--buttonWrapper").on("click", () => {
    if ($(SUBMIT_BUTTON).is(":disabled")) {
      showValidationErrors();
    }
  });

  $(window).on("load", updateFormLock);
});

function updateFormLock() {
  const unlocked =
    hasSelectedProject() && isConsentChecked() && hasVerificationMethod();

  $(SUBMIT_BUTTON).prop("disabled", !unlocked);
}

function hasSelectedProject() {
  return (
    $(LOCAL_PROJECT_SELECT).val() !== "" || $(CITY_PROJECT_SELECT).val() !== ""
  );
}

function isConsentChecked() {
  return $(CONSENT_CHECKBOX).is(":checked");
}

function hasVerificationMethod() {
  return $(VERIFICATION_INPUT + ":checked").length > 0;
}

function showValidationErrors() {
  if (!isFormValid()) {
    scrollToFirstError();
  }
}

function isFormValid() {
  const projectsValid = validateProjects();
  const consentValid = validateConsent();
  const verificationValid = validateVerification();

  return projectsValid && consentValid && verificationValid;
}

function validateProjects() {
  const $localGroup = $(LOCAL_PROJECT_SELECT).closest(".project");
  const $cityGroup = $(CITY_PROJECT_SELECT).closest(".project");

  clearMessages($localGroup);
  clearMessages($cityGroup);

  const hasLocal = $(LOCAL_PROJECT_SELECT).val() !== "";
  const hasCity = $(CITY_PROJECT_SELECT).val() !== "";

  if (!hasLocal && !hasCity) {
    setError($localGroup, MESSAGE_SELECT_PROJECT);
    setError($cityGroup, MESSAGE_SELECT_PROJECT);
    return false;
  }

  if (!hasLocal) {
    setOptionalInfo($localGroup, MESSAGE_OPTIONAL_LOCAL);
  }
  if (!hasCity) {
    setOptionalInfo($cityGroup, MESSAGE_OPTIONAL_CITY);
  }

  return true;
}

function validateConsent() {
  const $group = $(CONSENT_CHECKBOX).closest(".form-group--checkbox");
  const isChecked = isConsentChecked();

  if (isChecked) {
    clearMessages($group);
  } else {
    setError($group, MESSAGE_CONSENT_REQUIRED, "prepend");
  }

  return isChecked;
}

function validateVerification() {
  const $group = $(VERIFICATION_GROUP);
  const isSelected = hasVerificationMethod();

  if (isSelected) {
    clearMessages($group);
  } else {
    setError($group, MESSAGE_VERIFICATION_REQUIRED);
  }

  return isSelected;
}

function setError($container, message, position) {
  $container.addClass("errorField");
  ensureMessage($container, "errorMessage", position).text(message).show();
}

function setOptionalInfo($container, message) {
  ensureMessage($container, "optionalMessage").text(message).show();
}

function clearMessages($container) {
  $container.removeClass("errorField");
  $container.children(".errorMessage, .optionalMessage").remove();
}

function ensureMessage($container, className, position) {
  let $message = $container.children("." + className);

  if (!$message.length) {
    $message = $("<span>").addClass(className);
    if (position === "prepend") {
      $container.prepend($message);
    } else {
      $container.append($message);
    }
  }

  return $message;
}

function scrollToFirstError() {
  const $firstError = $("#formVote .errorField").first();

  if (!$firstError.length) {
    return;
  }

  $("html, body").animate(
    { scrollTop: $firstError.offset().top - HEADER_OFFSET },
    400,
  );

  focusFirstError($firstError);
}

function focusFirstError($errorField) {
  let $target = $errorField
    .find("select, input, textarea, button, a[href], [tabindex]")
    .filter(":visible")
    .first();

  if (!$target.length) {
    $errorField.attr("tabindex", "-1");
    $target = $errorField;
  }

  $target.get(0)?.focus({ preventScroll: true });
}
